import { Link } from "react-router-dom";
import { T } from "../../theme/tokens";

// The one page template. Header/Footer come from <Shell>; pages compose PageHero + Section + Card + Button.
export function Page({ children, testId = "page", className = "" }) {
  return <main className={`${T.page} ${className}`} data-testid={testId}>{children}</main>;
}

export function PageHero({ eyebrow, title, lead, aside, actions, children, testId = "page-hero" }) {
  return (
    <section className="border-b" style={{ background: "var(--ut-panel)", borderColor: "var(--ut-line)" }} data-testid={testId}>
      <div className={`${T.container} pt-14 pb-12 sm:pt-20 sm:pb-16 grid gap-10 ${aside ? "lg:grid-cols-[1.2fr_1fr] items-center" : ""}`}>
        <div>
          {eyebrow && <p className={T.eyebrow}>{eyebrow}</p>}
          <h1 className={`${T.h1} text-4xl sm:text-5xl lg:text-6xl mt-4`}>{title}</h1>
          {lead && <p className={`${T.lead} mt-6 text-base md:text-lg`}>{lead}</p>}
          {children}
          {actions && <div className="mt-8 flex flex-wrap gap-3">{actions}</div>}
        </div>
        {aside}
      </div>
    </section>
  );
}

export function Section({ id, eyebrow, title, lead, children, band = false, narrow = false, testId }) {
  return (
    <section id={id} className={`${T.container} mt-16 sm:mt-24 scroll-mt-24`} data-testid={testId}>
      <div className={`${band ? "ut-band px-6 sm:px-10 py-10 sm:py-14" : ""} ${narrow ? "max-w-3xl" : ""}`}>
        {(eyebrow || title) && (
          <header className="mb-8 sm:mb-10">
            {eyebrow && <p className={T.eyebrow}>{eyebrow}</p>}
            {title && <h2 className={`${T.h2} text-3xl sm:text-4xl mt-2`}>{title}</h2>}
            {lead && <p className={`${T.lead} mt-4`}>{lead}</p>}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}

export function Card({ children, className = "", as: As = "div", ...rest }) {
  return <As className={`${T.card} p-6 ${className}`} {...rest}>{children}</As>;
}

export function Button({ to, href, children, variant = "primary", className = "", ...rest }) {
  const cls = `${variant === "ghost" ? T.btnGhost : T.btnPrimary} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button type="button" className={cls} {...rest}>{children}</button>;
}

export function Divider() {
  return <div className={`${T.divider} justify-center mt-3`} aria-hidden="true"><span /></div>;
}
